module.exports = __webpack_public_path__ + "img/Enzymotherapy17.cdd0a969.jpg";